<script>
  import { SPRITESHEET_URL } from '../../utils/constants';
  import { openOverpanel } from '../../stores/overpanelControl';
  import location from '../../stores/currentLocation';
  import { trackEvent } from '../../utils/umami-events.js';

  let {
    content,
    instructionAriaText,
    locationAriaTemplate,
    editLabelText,
    inOverpanel = false,
    callback = () => {},
    closeCallback = () => {},
    currentState,
    dataTestId = 'location-control',
    locationControl = $bindable(undefined),
  } = $props();

  const onClick = () => {
    openOverpanel('location', {
      closeCallback: () => {
        closeCallback();
      },
    });
    callback();

    trackEvent(`change-location${inOverpanel ? '-overpanel' : ''}`, { originalLocation: $location ? $location.zip : 'None'});
  };

  let text = $state(instructionAriaText);
  let ariaLabel = $derived(text);

  location.subscribe((value) => {
    if (value && locationAriaTemplate) {
      text = locationAriaTemplate.replace(
        '{{ADDRESS}}',
        [value.city, value.state, value.zip].filter((val) => val).join(', ')
      );
    } else {
      text = instructionAriaText;
    }
  });
</script>

{#if currentState && (currentState.initializing || currentState.pending)}
  <div class="w-full shadow-sm h-14 py-4">
    <div class="max-w-6xl mx-auto flex items-center px-4">
      <svg
        class="fill-blue-cerulean h-5 w-5 lg:h-6 lg:w-6 mr-4 flex-none"
        class:md:mr-2={!inOverpanel}
        role="presentation"
      >
        <use xlink:href="{SPRITESHEET_URL}location-pin" />
      </svg>
      <div class="w-full flex items-baseline justify-between leading-normal font-semibold text-sm">
        <div class="h-4 skeleton-gradient animated-skeleton w-40"></div>
        <div class="h-4 skeleton-gradient animated-skeleton w-8"></div>
      </div>
    </div>
  </div>
{:else}
  <button
    class="w-full text-blue-cerulean hover:text-blue-darkish focus:relative focus:outline-hidden group"
    class:md:w-auto={!inOverpanel}
    class:active:shadow-inset-active={inOverpanel}
    class:focus:shadow-inset-focus={inOverpanel}
    class:shadow-sm={$location && inOverpanel}
    class:bg-white={($location && inOverpanel) || inOverpanel}
    class:mobile:bg-blue-cerulean={!$location}
    class:mobile:text-white={!$location}
    class:mobile:hover:text-white={!$location}
    class:mobile:hover:bg-blue-darkish={!$location}
    class:mobile:active:bg-blue-darkish={!$location}
    class:mobile:focus:bg-blue-darkish={!$location}
    class:py-3={!inOverpanel}
    class:md:justify-end={!inOverpanel}
    class:md:py-0={!inOverpanel}
    class:md:bg-blue-cerulean={!$location && inOverpanel}
    class:md:text-white={!$location && inOverpanel}
    class:md:hover:text-white={!$location && inOverpanel}
    class:md:hover:bg-blue-darkish={!$location && inOverpanel}
    class:md:active:bg-blue-darkish={!$location && inOverpanel}
    class:md:focus:bg-blue-darkish={!$location && inOverpanel}
    class:py-4={inOverpanel}
    class:lg:pr-0={!inOverpanel}
    class:lg:pl-16={!inOverpanel}
    data-testid={dataTestId}
    bind:this={locationControl}
    onclick={onClick}
    aria-label={ariaLabel}
  >
    <div 
      class="max-w-6xl mx-auto w-full flex items-center px-4"
      class:lg:pr-0={!inOverpanel}
    >
      <svg
        class="fill-current h-5 w-5 lg:h-6 lg:w-6 mr-4 flex-none"
        class:md:mr-2={!inOverpanel}
        role="presentation"
      >
        <use xlink:href="{SPRITESHEET_URL}location-pin" />
      </svg>
      {#if $location}
        <div
          class="w-full flex items-baseline justify-between leading-normal font-semibold text-sm"
          class:lg:text-base={!inOverpanel}
          class:md:justify-normal={!inOverpanel}
        >
          <div class="text-nowrap" class:md:font-normal={!inOverpanel} class:md:text-blue-navy={!inOverpanel}>
            {#if $location.city && $location.state}
              <span data-testid="{dataTestId}-city-label">{$location.city},</span>
              <span data-testid="{dataTestId}-state-label">{$location.state}</span>
            {/if}
            {#if $location.zip}
              <span data-testid="{dataTestId}-zip-label">{` • ${$location.zip}`}</span>
            {/if}
          </div>
          <div class="ml-2 text-blue-cerulean font-semibold hover-hover:group-hover:text-blue-navy text-sm hover-hover:group-hover:underline group-active:underline">
            {#if !inOverpanel}
              <div class="flex">              
                <span class="hidden md:block">(</span>
                {editLabelText}
                <span class="hidden md:block">)</span>
              </div>
            {:else}
              {editLabelText}
            {/if}
          </div>
        </div>
      {:else}
        <div
          class="text-left font-normal leading-tight whitespace-nowrap"
          class:text-sm={!inOverpanel}
          class:lg:text-base={!inOverpanel}
        >
          {@html content}
        </div>
      {/if}
    </div>
  </button>
{/if}